import {DropdownItem} from '@blocks/rich-text/dropdown-item';

export const EDITOR_HEADERS: DropdownItem[] = [
  {label: 'text'},
  {label: 'h1', value: 1},
  {label: 'h2', value: 2},
  {label: 'h3', value: 3},
  {label: 'h4', value: 4},
  {label: 'h5', value: 5},
  {label: 'h6', value: 6}
];

export const EDITOR_SIZES: DropdownItem[] = [
  {value: '8'},
  {value: '9'},
  {value: '10'},
  {value: '11'},
  {value: '12'},
  {value: '13'},
  {value: '14'},
  {value: '15'},
  {label: '16', value: '16'},
  {value: '18'},
  {value: '24'}
];
